import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";
import CustomStore from 'devextreme/data/custom_store';
import {ToastsManager} from "ng2-toastr";
import {LoggerService} from "../services/logger.service";

@Component({
  selector: 'app-logger',
  templateUrl: './logger.component.html',
  styleUrls: ['./logger.component.scss']
})
export class LoggerComponent implements OnInit {

  public password: any;
  public files: any;
  public logData: string;
  public activeLogDate: string;

  constructor(public editDataService: EditDataService
    , public toastr: ToastsManager
    , public vRef: ViewContainerRef
    , public loggerService: LoggerService) {

    this.password = this.editDataService.password;
  }

  ngOnInit() {
    this.loggerService.getFiles(this.password).subscribe(data => {
      this.files = data.files;
      if (data.files.length > 0) {
        this.getLog(data.files[0])
      }
    });
  }

  public getLog(log) {
    this.logData = '';
    this.activeLogDate = log.name;
    this.loggerService.getLog(log).then(data => {
      this.logData = data;
    });
  };

  public removeLog(log) {
    this.loggerService.removeFiles(log.name, this.password).subscribe(data => {
      this.files = data.files;
      if (data.files.length > 0) {
        this.getLog(data.files[0])
      }
    },(err) => {
      let error = JSON.parse(err._body);
      this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
    });
  };

}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/logger/logger.component.ts